type EmbedBilibiliVideoProps = {
  url: string;
};
const EmbedBilibiliVideo = ({ url }: EmbedBilibiliVideoProps) => {
  const getBilibiliEmbedId = (url: string) => {
    const bvidMatch = url.match(/bilibili\.com\/video\/(BV\w+)/);
    return bvidMatch ? bvidMatch[1] : null;
  };

  const embedId = getBilibiliEmbedId(url);

  return (
    embedId && (
      <div className="aspect-video w-full">
        <iframe
          className="h-full w-full rounded-lg"
          src={`//player.bilibili.com/player.html?bvid=${embedId}&page=1&autoplay=0`}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;fullscreen;"
          allowFullScreen
          title="Embedded Bilibili"
        ></iframe>
      </div>
    )
  );
};

export default EmbedBilibiliVideo;
